module.exports = __webpack_public_path__ + "img/Frame-29.ea5ef686.svg";